import { useState } from 'react';
import { LogOut } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';
import { useAuth } from '@/hooks/use-auth';

export function SidebarUserMenu() {
  const [open, setOpen] = useState(false);
  const { currentUser, signOut } = useAuth();
  const name = currentUser?.name || currentUser?.email || '';
  const initial = (name[0] || '?').toUpperCase();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className='mx-auto flex h-8 w-8 items-center justify-center rounded-full border border-border bg-white text-sm font-medium text-foreground transition-colors hover:bg-muted'>
          {initial}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side='right'
        align='end'
        sideOffset={12}
        className='w-56 rounded-xl border border-border bg-white p-2 shadow-sm'
      >
        <div className='flex items-center gap-2.5 px-2 py-2'>
          <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm font-medium text-foreground'>
            {initial}
          </div>
          <div className='min-w-0'>
            <p className='truncate text-sm font-semibold'>{name}</p>
            <p className='truncate text-xs text-muted-foreground'>
              {currentUser?.email}
            </p>
          </div>
        </div>
        <div className='mx-2 mb-1 border-t border-border' />
        <button
          onClick={signOut}
          className='flex w-full items-center justify-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-xs font-medium text-red-500 transition-colors hover:bg-red-100'
        >
          <LogOut className='size-3' />
          Log out
        </button>
      </PopoverContent>
    </Popover>
  );
}
